import { IAppState } from 'spw-redux/reducer';

export const selectToastMessage = (state: IAppState) =>
  state.messagesReducer.toastMessage;

export const selectVersionFetchComplete = (state: IAppState) =>
  state.messagesReducer.versionFetchComplete;
